export const validationKorean = (value: string): boolean => {
  const regex = /^[ㄱ-ㅎ가-힣0-9\s]+$/;
  return regex.test(value);
};

export const validationEnglish = (value: string): boolean => {
  const regex = /^[a-zA-Z0-9\s']+$/;
  return regex.test(value);
};

export const validationKoreanAndCharacter = (value: string): boolean => {
  const regex = /^[ㄱ-ㅎ가-힣0-9\][@#-_$%^&*()\s]+$/;
  return regex.test(value);
};

export const validateEnglishAndCharacter = (value: string): boolean => {
  const regex = /^[a-zA-Z0-9\][@#-_$%^&*()\s']+$/;
  return regex.test(value);
};

export const isEmail = (email: string): boolean =>
  /^(?:[\w_.\-+])+@(?:[\w-]+\.)+(?:[\w]{2,10})+$/.test(email);

export const isFileSizeOver20MB = (file: File) => file?.size > 20000000;

export const isAnyFileOver20MB = (files: File[]) =>
  files.some((file) => isFileSizeOver20MB(file));

export const isAnyFileNotImage = (files: File[]) =>
  files.some((file) => !file?.type?.startsWith("image/"));
